import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import PageSection from "../../pageSection/pageSection.js"

import styles from "./pressBanner.module.scss"

import badgeBestGold from "../../../images/home/badge-best-gold.svg"

const PressBannerSection = () => {
  const data = useStaticQuery(graphql`
    query {
      yahooImage: file(relativePath: { eq: "home/yahoo-finance.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 151
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      techCrunchImage: file(relativePath: { eq: "home/tech-crunch.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 80
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      fortuneImage: file(relativePath: { eq: "home/fortune.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 194
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `)

  return (
    <PageSection backgroundColor="#5650F0">
      <div className={styles.root}>
        <div className={styles.innerContainer}>
          <div className={styles.usNewsContainer}>
            <OutboundLink style={{ display: "contents" }} href="https://money.usnews.com/money/personal-finance/saving-and-budgeting/slideshows/best-budget-apps?slide=6" target="_blank" rel="noopener noreferrer">
              <img
                src={badgeBestGold}
                className={styles.usNewsImg}
                alt="U.S. news and world report best ranking logo"
              />
            </OutboundLink>
            <p className={styles.usNewsLabel}>
             <span className={styles.usNewsLabelBold}>Named <em>“Best App for Teaching Teens to Budget”</em> by US News & World Report</span>
            </p>
          </div>

          <div className={styles.featuredOnContainer}>
            <p className={styles.featuredOnLabel}>FEATURED ON</p>
            <div className={styles.featuredOnImgContainer}>
              <div className={`${styles.yahooImgRoot} ${styles.logoWrapper}`}>
                <div className={styles.imgContainer}>
                  <OutboundLink href="https://finance.yahoo.com/video/lets-demystify-process-teaching-kids-180032781.html" target="_blank" rel="noopener noreferrer">
                    <GatsbyImage image={getImage(data.yahooImage)} alt="Yahoo finance logo" />
                  </OutboundLink>
                </div>
              </div>
              <div className={`${styles.techCrunchImgRoot} ${styles.logoWrapper}`}>
                <div className={styles.imgContainer}>
                  <OutboundLink href="https://techcrunch.com/2021/04/22/forget-the-piggy-bank-till-financials-kids-spend-management-app-gets-gates-backing/" target="_blank" rel="noopener noreferrer">
                    <GatsbyImage image={getImage(data.techCrunchImage)} alt="Tech Crunch logo" />
                  </OutboundLink>
                </div>
              </div>
              <div className={`${styles.fortuneImgRoot} ${styles.logoWrapper}`}>
                <div className={styles.imgContainer}>
                  <GatsbyImage image={getImage(data.fortuneImage)} alt="Fortune logo" />
                </div>
              </div>
              <div className={`${styles.realSimpleImgRoot} ${styles.logoWrapper}`}>
                <div className={styles.imgContainer}>
                 <OutboundLink href="https://www.realsimple.com/work-life/money/best-financial-apps-2022" target="_blank" rel="noopener noreferrer">
                    <p>2022 Real Simple Smart Money Awards Winner</p>
                  </OutboundLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageSection>
  )
};

export { PressBannerSection }
